import { render, staticRenderFns } from "./OrganizationWebsiteInput.vue?vue&type=template&id=2bccd32c"
import script from "./OrganizationWebsiteInput.vue?vue&type=script&lang=js"
export * from "./OrganizationWebsiteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports